import { useState, useEffect, useCallback } from 'react';
import { Editor } from '@tiptap/react';

export function useEditorReady(editor: Editor | null): boolean {
  const [isReady, setIsReady] = useState<boolean>(false);

  const handleReady = useCallback(() => {
    setIsReady(true);
  }, []);

  useEffect(() => {
    if (!editor) return;
    
    editor.on('create', handleReady);
    return () => {
      editor.off('create', handleReady);
    };
  }, [editor, handleReady]);

  return isReady;
} 